import Vue from 'vue'
import Vuex from 'vuex'

import accounts from './modules/accounts'
import alerts from './modules/alerts'
import auth from './modules/auth'
import console from './modules/console'
import customer_requests from './modules/customer_requests'
import dashboards from './modules/dashboards'
import devices from './modules/devices'
import filters from './modules/filters'
import pros from './modules/pros'
import qr from './modules/qr'
import referrals from './modules/referrals'
import rewards from './modules/rewards'
import services from './modules/services'
import trades from './modules/trades'
import users from './modules/users'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    accounts,
    alerts,
    auth,
    console,
    customer_requests,
    dashboards,
    devices,
    filters,
    pros,
    qr,
    referrals,
    rewards,
    services,
    trades,
    users,
  },
  
  strict: debug,
})

